/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} Tournaments_Page_InfoInputs */



/**
* | output |
* | --- |
* | "Page {current} of {total}" |
*
* @param {Tournaments_Page_InfoInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_page_info = /** @type {((inputs: Tournaments_Page_InfoInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Page_InfoInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Page ${i?.current} sur ${i?.total}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Página ${i?.current} de ${i?.total}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Página ${i?.current} de ${i?.total}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Pagina ${i?.current} di ${i?.total}`)
	return /** @type {LocalizedString} */ (`Page ${i?.current} of ${i?.total}`)
});